import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const LinkDetail = styled.div({
    cursor:'pointer',
    fontWeight:'bold',
    ':hover':{
        color:v.ezOrange
    }
});